import React from 'react';

const CloseIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g>
      <circle cx='16' cy='16' r='12' fill='currentColor' />
      <g stroke='#FFF' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2'>
        <path d='M0 0L10 10' transform='translate(11 11)' />
        <path d='M0 0L10 10' transform='translate(11 11) matrix(-1 0 0 1 10 0)' />
      </g>
    </g>
  </svg>
);

export default CloseIcon;
